import { Field } from 'formik'

import ToggleButton from 'components/ToggleButton'

const ClassificationsDetails = ({
  reportingCategories,
  id,
  showValidationErrors,
}) => {
  return (
    <div className="item-classifications" id={id}>
      <h3 className="header-title">Classifications</h3>
      <div className="content-wrapper -flags-wrapper">
        <span className="content-header">Alcohol</span>
        <span className="content-value">
          <Field
            component={ToggleButton}
            name="alcohol"
            type="checkbox"
          />
        </span>
      </div>
      <div className="content-wrapper -flags-wrapper">
        <span className="content-header">Discountable</span>
        <span className="content-value">
          <Field
            component={ToggleButton}
            name="discountable"
            type="checkbox"
          />
        </span>
      </div>
      <div className="content-wrapper -flags-wrapper">
        <span className="content-header">Fast Fulfill</span>
        <span className="content-value">
          <Field
            component={ToggleButton}
            name="autoAdvance"
            type="checkbox"
          />
        </span>
      </div>
    </div>
  )
}

export default ClassificationsDetails
